import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const Footer = () => {
  const [showFooter, setShowFooter] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrolledToBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100;
      setShowFooter(scrolledToBottom);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.footer className="fixed bottom-0 left-0 right-0 py-4 bg-gradient-to-t from-white/95 to-transparent backdrop-blur-sm" initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: showFooter ? 1 : 0,
    y: showFooter ? 0 : 20
  }} transition={{
    duration: 0.3
  }} data-id="element-76">
      <div className="container mx-auto px-4 text-center" data-id="element-77">
        <p className="text-sm text-gray-500" data-id="element-78">
          © {new Date().getFullYear()} nickszusehen. Alle Rechte vorbehalten.
        </p>
      </div>
    </motion.footer>;
};
export default Footer;